import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import { WHITE, PRIMARY_COLORS } from '../../common/colors';
import { appLink } from '../../common/appLinks';
import heroIllustration from '../../assets/Group-4_1.avif';

// Webflow header37: brand-primary section, white copy left, line-art
// illustration right; "Search OCL Online" (white pill) + "Explore the tools"
// (outlined-white pill) CTAs. The design's second CTA, "Getting Started" →
// /guides, points at /tools while guides are offline (ocl_online#215).
const Hero = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ backgroundColor: 'primary.main' }}>
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 8 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            alignItems: 'center',
            gap: { xs: 8, md: 4 },
          }}>
          <Box>
            <Typography variant="h1" sx={{ color: WHITE, fontSize: { xs: '2.5rem', md: '3.5rem' }, mb: 3 }}>
              {t('home.hero.title')}
            </Typography>
            <Typography sx={{ color: WHITE, fontSize: '1.125rem', mb: 4 }}>
              {t('home.hero.subtitle')}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <Button
                href={appLink('termBrowser', '/search/')}
                startIcon={<ManageSearchIcon />}
                sx={{
                  backgroundColor: WHITE,
                  color: 'surface.dark',
                  px: 3,
                  py: 1.5,
                  '&:hover': { backgroundColor: PRIMARY_COLORS['90'] },
                }}>
                {t('home.hero.search_button')}
              </Button>
              <Button
                component={RouterLink}
                to="/tools"
                startIcon={<ExploreOutlinedIcon />}
                sx={{
                  border: `1px solid ${WHITE}`,
                  color: WHITE,
                  px: 3,
                  py: 1.5,
                  '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
                }}>
                {t('home.hero.tools_button')}
              </Button>
            </Box>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Box
              component="img"
              src={heroIllustration}
              alt={t('home.hero.illustration_alt')}
              sx={{ width: '100%', maxWidth: 525, height: 'auto' }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
